import Form, { FormSchema } from '@sezenta/antd-schema-form';
import { useConnection, useUser } from '@sezenta/connection';
import { Button, message, notification } from 'antd';
import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBusinessContext } from '../../context/BusinessContext';
import { setFormValidationErrors } from '../../common/Utils';

const PasswordSettings = () => {
  const connection = useConnection();
  const { businessId } = useBusinessContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();

  const schema1: FormSchema = [
    {
      id: 'currentPassword',
      type: 'password',
      name: '',
      props: { placeholder: 'Current Password' },
      options: {
        rules: [{ required: true, message: 'Current Password is required' }],
      },
    },
  ];

  const schema2: FormSchema = [
    {
      id: 'password',
      type: 'password',
      name: '',
      props: { placeholder: 'New Password' },
      options: {
        rules: [{ required: true, message: 'New Password is required' }],
      },
    },
  ];

  const schema3: FormSchema = [
    {
      id: 'confirmPassword',
      type: 'password',
      name: '',
      props: { placeholder: 'Confirm Password' },
      options: {
        rules: [
          { required: true, message: 'Confirm Password is required' },
          {
            validator: (_: any, value: any) =>
              value && value === form.getFieldValue('password')
                ? Promise.resolve()
                : Promise.reject(new Error('Passwords do not match')),
          },
        ],
      },
    },
  ];

  const onFinish = useCallback(
    async (data: any) => {
      setLoading(true);
      connection
        .post(`/auth/${businessId}/user/change-password`, {
          currentPassword: data.currentPassword,
          password: data.password,
        })
        .then((res) => {
          if (res.status === 201) {
            api.success({
              message: 'Password Reset',
              description: 'Password reset successfully',
            });
            form.resetFields();
          }
        })
        .catch((reason) => {
          if (!setFormValidationErrors(form, reason)) {
            message.error('Failed to save');
          }
          api.error({
            message: 'Password Reset',
            description: 'Failed to reset password',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [connection, api, businessId, form],
  );

  return (
    <div className="w-ful h-full">
      <div className="flex flex-col">
        <p className="font-semibold text-[16px]">Password</p>
        <p className="text-gray-500">
          Update your password to keep your account secure
        </p>
      </div>
      <Form form={form} onFinish={onFinish} className="mt-7 w-full md:w-[60%] lg:w-[40%]">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[500px]">
            <tr>
              <td className="flex items-start font-semibold pr-4 py-2">
                Current Password
              </td>
              <td className="py-2">
                <Form.Items schema={schema1} />
              </td>
            </tr>
            <tr>
              <td className="flex items-start font-semibold pr-4 py-2">
                New Password
              </td>
              <td className="py-2">
                <Form.Items schema={schema2} />
              </td>
            </tr>
            <tr>
              <td className="flex items-start font-semibold pr-4 py-2">
                Confirm Password
              </td>
              <td className="py-2">
                <Form.Items schema={schema3} />
              </td>
            </tr>
          </table>
        </div>
        <Button
          loading={loading}
          disabled={loading}
          type="primary"
          htmlType="submit"
          className="mt-5"
        >
          Update
        </Button>
      </Form>
      {contextHolder}
    </div>
  );
};

export default PasswordSettings;
